import { Routes } from '@angular/router';
import { HomeComponent } from './features/home/home.component';
import { NewsEditorComponent } from './features/news-editor/news-editor.component';
import { LoginComponent } from './features/auth/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { EditorGuard } from './core/guards/editor.guard';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  { path: 'home', component: HomeComponent },
  { path: 'la-ciudad', component: HomeComponent }, // Temporalmente usando HomeComponent
  { path: 'economia', component: HomeComponent },  // Temporalmente usando HomeComponent
  { path: 'deportes', component: HomeComponent },  // Temporalmente usando HomeComponent
  { path: 'mundo', component: HomeComponent },     // Temporalmente usando HomeComponent
  { path: 'pronostico', component: HomeComponent }, // Temporalmente usando HomeComponent
  {
    path: 'categoria/:category',
    loadComponent: () => import('./features/category-news/category-news.component').then(m => m.CategoryNewsComponent)
  },
  {
    path: 'ind-arg',
    loadComponent: () => import('./features/category-news/category-news.component').then(m => m.CategoryNewsComponent),
    data: { category: 'ind.arg' }
  },
  { path: 'login', component: LoginComponent },
  {
    path: 'noticias/:slug',
    loadComponent: () => import('./features/news-viewer/news-viewer.component').then(m => m.NewsViewerComponent)
  },
  { 
    path: 'admin', 
    children: [
      { 
        path: '',
        redirectTo: 'editor',
        pathMatch: 'full'
      },
      { 
        path: 'editor',
        component: NewsEditorComponent,
        canActivate: [EditorGuard], // Permitir editores generales y admins
        title: 'Editor de Noticias'
      },
      {
        path: 'editores',
        loadComponent: () => import('./features/admin/editor-management/editor-management.component')
          .then(m => m.EditorManagementComponent),
        canActivate: [AdminGuard], // Solo admins pueden gestionar editores
        title: 'Gestión de Editores'
      },
      {
        path: 'crear-admin',
        loadComponent: () => import('./features/admin/create-admin/create-admin.component')
          .then(m => m.CreateAdminComponent),
        canActivate: [AdminGuard], // Solo admins pueden crear admins
        title: 'Crear Administrador'
      }
    ]
  }
];
